import Vue from 'vue'

export function loadHas() {
  Vue.directive('has', {
    bind(el, binding, vnode) {
      let permTypes = vnode.context.$route.meta.permTypes || []

      let bindingValue = Array.isArray(binding.value) ? binding.value : [binding.value]

      let arr = []

      bindingValue.forEach((item) => {
        arr.push(permTypes.includes(item))
      })

      if (!arr.some((it) => it)) {
        el.style.display = 'none'
      }
    }
  })
}
